var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TeamStatusControl',{attrs:{"subject":_vm.slide.settings.subject,"type":"votes"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }